/** Support tickets: Administration → Tickets (ADR-0076; it was the Validation
 *  group's last entry under ADR-0069), Administrators only. A ticket is
 *  `${TICKETS_PATH}/<ticket id>`. */
export const TICKETS_PATH = "/admin/tickets";
